import { jsxs, jsx } from 'react/jsx-runtime';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/button.js';
import '@radix-ui/react-progress';
import '@clerk/clerk-react';
import { X, ChevronDown, Check } from 'lucide-react';
import { useState } from 'react';
import '../../lib/toast.js';
import 'react-router-dom';
import { Button } from '../page-layout/Button.js';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../page-layout/FormPageLayout.js';
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from '../ui/command.js';
import { Popover, PopoverTrigger, PopoverContent } from '../ui/popover.js';
import './RichTextEditor.js';
import '@radix-ui/react-switch';
import '@radix-ui/react-dialog';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';
import { Badge } from '../ui/badge.js';
import 'react-day-picker';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';

function MultiSelectCombobox({ options, value = [], onChange, placeholder = 'Select...', searchPlaceholder = 'Search...', emptyText = 'No options found.', className, disabled = false, }) {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const filteredOptions = search
        ? options.filter(opt => opt.label.toLowerCase().includes(search.toLowerCase()))
        : options;
    const handleToggle = (optionValue) => {
        if (value.includes(optionValue)) {
            onChange(value.filter(v => v !== optionValue));
        }
        else {
            onChange([...value, optionValue]);
        }
    };
    const handleRemove = (optionValue, e) => {
        e.stopPropagation();
        onChange(value.filter(v => v !== optionValue));
    };
    const selectedLabels = value
        .map(v => options.find(opt => opt.value === v)?.label)
        .filter(Boolean);
    return (jsxs(Popover, { open: open, onOpenChange: setOpen, children: [jsx(PopoverTrigger, { asChild: true, children: jsxs(Button, { variant: "outline", role: "combobox", "aria-expanded": open, disabled: disabled, className: cn('w-full justify-between min-h-9', className), children: [jsx("div", { className: "flex items-center gap-1 flex-1 overflow-hidden", children: value.length === 0 ? (jsx("span", { className: "text-muted-foreground font-normal", children: placeholder })) : value.length <= 2 ? (jsx("div", { className: "flex items-center gap-1 flex-wrap", children: selectedLabels.map((label, i) => (jsxs(Badge, { variant: "secondary", className: "text-xs px-1.5 py-0 h-5 font-normal", children: [label, jsx("button", { type: "button", className: "ml-1 hover:text-foreground", onClick: (e) => handleRemove(value[i], e), children: jsx(X, { className: "h-3 w-3" }) })] }, value[i]))) })) : (jsxs(Badge, { variant: "secondary", className: "text-xs px-1.5 py-0 h-5 font-normal", children: [value.length, " selected"] })) }), jsx(ChevronDown, { className: "ml-2 h-4 w-4 shrink-0 opacity-50" })] }) }), jsx(PopoverContent, { className: "w-(--radix-popover-trigger-width) min-w-[200px] p-0", align: "start", children: jsxs(Command, { shouldFilter: false, children: [jsx(CommandInput, { placeholder: searchPlaceholder, value: search, onValueChange: setSearch }), jsxs(CommandList, { children: [jsx(CommandEmpty, { children: emptyText }), jsx(CommandGroup, { children: filteredOptions.map(option => {
                                        const isSelected = value.includes(option.value);
                                        return (jsxs(CommandItem, { value: option.value, onSelect: () => handleToggle(option.value), children: [jsx(Check, { className: cn('mr-2 h-4 w-4', isSelected ? 'opacity-100' : 'opacity-0') }), option.label] }, option.value));
                                    }) })] })] }) })] }));
}

export { MultiSelectCombobox };
//# sourceMappingURL=MultiSelectCombobox.js.map
